<template>
  <md-menu md-size="small">
    <a href="#" @click.prevent="dummy" md-menu-trigger>{{ text }}</a>
    <md-menu-content>
      <md-menu-item @click="$emit('select', 'category')">分類別</md-menu-item>
      <md-menu-item @click="$emit('select', 'store')">店舗別</md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },
  methods: {
    dummy() {
      // NOP
      // hrefがないとカーソルが変わらなかったりするのでhrefを入れたいが、
      // そうするとクリック時にスクロール位置がトップに移動してしまう。
      // preventDefaultするためだけのクリックハンドラを作成
    },
  },
}
</script>
